
import { defineComponent, PropType } from 'vue'

import RouteSheetStatus from '@/modules/NewDispatcher/components/RouteSheetStatus/index.vue'

import { formatDateWithTimeFromBackend } from '@/common/helpers/formatDate'

export default defineComponent({
    components: {
        RouteSheetStatus,
    },
    props: {
        row: {
            type: Object as PropType<any>,
            default: null,
        },
        column: {
            type: Object as PropType<any>,
            default: null,
        },
    },
    setup() {
        return {
            formatDateWithTimeFromBackend
        }
    }
})
